import React from 'react';

export const useOutsideClick = <TTarget extends HTMLElement>(
  callback?: (event: Event) => void
) => {
  const targetNodeRef = React.useRef<TTarget | null>(null);

  React.useEffect(() => {
    if (!callback) {
      return;
    }

    const targetNode = targetNodeRef.current;

    if (targetNode) {
      const callbackProxy = (event: Event) => {
        if (
          event.target instanceof HTMLElement &&
          !targetNode.contains(event.target)
        ) {
          callback(event);
        }
      };

      window.addEventListener('mouseup', callbackProxy);

      return () => {
        window.removeEventListener('mouseup', callbackProxy);
      };
    }
  }, [callback]);

  return targetNodeRef;
};
